/**
 * Kamus **layar dapur (KDS)**.
 *
 * ⚠️ Kata-katanya sengaja pendek dan bukan bahasa kantor. Yang membacanya sedang berdiri satu-dua
 * meter dari layar sambil memegang penjepit — kalimat panjang di sini sama saja dengan tak ada
 * tulisan sama sekali.
 */
export const kdsId = {
  density: 'Kartu per layar',
  densityOption: '{{n}} kartu',
  /* ⭐ Kemudi satu-kartu di layar selebar HP. Sependek mungkin — tombolnya berdampingan. */
  nav: { prev: 'Sebelum', next: 'Lanjut', pos: '{{i}}/{{n}}' },
  tag: {
    table: 'Meja {{label}}',
    queue: 'Antrean {{label}}',
    /** ⭐ Nama tamu & nomor pesanan dipakai apa adanya — awalan cuma memakan lebar kartu. */
    plain: '{{label}}',
  },
  allDay: {
    title: 'Total dimasak',
    tickets: '{{count}} tiket',
    markSoldOut: 'HABIS',
    cancel: 'Batal',
  },
  /* ⭐ Jenis penanda — DISEBUT, karena nama tamu boleh berupa angka dan tanpa ini ia tak bisa
     dibedakan dari nomor antrean. */
  kind: { table: 'MEJA', queue: 'ANTREAN', name: 'NAMA', none: 'TANPA TANDA' },
  station: 'Stasiun',
  pending: '{{count}} tiket',
  empty: 'Belum ada yang masuk',
  loadFailed: 'Daftar tiket gagal dimuat',
  /* ⛔ Disebut apa adanya: kalau layar dapur melambat, orang di dapur harus tahu — bukan cuma log. */
  degraded: 'Sambungan langsung putus — layar disegarkan berkala',
  /* ⭐ "Susulan", bukan "ronde 2": yang dimaksud adalah pesanan tambahan meja yang sama. */
  round: 'susulan {{n}}',
  start: 'Mulai masak',
  inProgress: 'Sedang dimasak',
  bump: 'Jadi',
  /* ⛔⛔ Menyolok dengan sengaja: tiket basi yang tak mengaku basi membuat dapur memasak pesanan
     yang sudah dibatalkan, dan tak ada satu pun tanda bahwa ada yang salah. */
  stale: 'DATA LAMA — {{age}} lalu, jaringan putus',
  /* ⭐ Antrean yang tak kasatmata tak dipercaya; angkanya disebut. */
  queued: '{{n}} "jadi" menunggu jaringan',
};

/**
 * Papan antrean tamu. ⚠️ Ini satu-satunya kamus yang dibaca **tamu**, bukan staf — jadi tak ada
 * istilah internal sama sekali ("tiket", "stasiun", "bump" haram muncul di sini).
 */
export const queueId = {
  preparing: 'Sedang disiapkan',
  ready: 'Silakan diambil',
  loadFailed: 'Papan gagal dimuat',
  degraded: 'Sambungan tersendat — papan mungkin telat beberapa detik',
  /* ⛔ Dikatakan apa adanya supaya layarnya tak dicabut orang karena dikira rusak (P8). */
  noTickets: 'Outlet ini tidak memakai layar antrean',
};

export const queueEn: typeof queueId = {
  preparing: 'Preparing',
  ready: 'Ready for pickup',
  loadFailed: 'Could not load the board',
  degraded: 'Connection lagging — the board may be a few seconds behind',
  noTickets: 'This outlet does not use the queue board',
};

export const kdsEn: typeof kdsId = {
  density: 'Cards per screen',
  densityOption: '{{n}} cards',
  nav: { prev: 'Prev', next: 'Next', pos: '{{i}}/{{n}}' },
  tag: {
    table: 'Table {{label}}',
    queue: 'Queue {{label}}',
    plain: '{{label}}',
  },
  allDay: {
    title: 'All day',
    tickets: '{{count}} tickets',
    markSoldOut: 'SOLD OUT',
    cancel: 'Cancel',
  },
  kind: { table: 'TABLE', queue: 'QUEUE', name: 'NAME', none: 'UNTAGGED' },
  station: 'Station',
  pending: '{{count}} tickets',
  empty: 'Nothing yet',
  loadFailed: 'Could not load tickets',
  degraded: 'Live connection lost — refreshing periodically',
  round: 'add-on {{n}}',
  start: 'Start',
  inProgress: 'Cooking',
  bump: 'Done',
  stale: 'STALE DATA — {{age}} old, network is down',
  queued: '{{n}} "done" waiting for the network',
};
